import Loader from '@platform-ui/loader';
import React from 'react';
import { RootWrapper } from '../../entrypoints/poll/Wrappers/RootWrapper';
import { WebviewCloseButton } from '../WebviewCloseButton';
import styles from './NewLoaderOverlay.module.css';

export const NewLoaderOverlay: React.FC<{
  isWebview: boolean;
  hideContentId?: boolean;
  onClose?: VoidFunction;
  flat?: boolean;
}> = ({ isWebview, flat, hideContentId, onClose }) => {
  const content = (
    <div className={styles.container}>
      <div aria-label="Загрузка" className={styles.loader}>
        <Loader size="xl" fadeAnimation="true" color={'var(--tui-background-accent-1)'} />
      </div>

      {isWebview && onClose && <WebviewCloseButton onClick={onClose} className={styles.closeButton} />}
    </div>
  );

  return (
    <div className={styles.wrapper} {...(!hideContentId && { id: 'content' })}>
      {flat ? content : <RootWrapper className={styles.wrapper}>{content}</RootWrapper>}
    </div>
  );
};
